export const CATEGORIAS = [
  { nombre: 'Abogado', icono: 'gavel' },
  { nombre: 'Animador', icono: 'mic' },
  { nombre: 'Arquitecto', icono: 'format_shapes' },
  { nombre: 'Asesoras / Limpieza Hogar',icono: 'home' },
  { nombre: 'Banda Musical / Músico', icono: 'music_note' },
  { nombre: 'Banquetera / Chef / Comida', icono: 'local_dining'},
  { nombre: 'Cerrajero', icono: 'vpn_key' },
  { nombre: 'Chofer', icono: 'drive_eta' },
  { nombre: 'Contador', icono: 'exposure' },
  { nombre: 'Corredor de propiedades', icono: 'home' },
  { nombre: 'Cosmetica', icono: 'face' },
  { nombre: 'Costurero', icono: 'accessibility' },
  { nombre: 'Dj',icono: 'audiotrack' },
  { nombre: 'Diseñador', icono: 'photo_size_select_large' },
  { nombre: 'Electricista', icono: 'wb_incandescent' },
  { nombre: 'Enfermeros', icono: 'local_pharmacy' },
  { nombre: 'Fonoaudiólogo', icono: 'record_voice_over' },
  { nombre: 'Fotógrafo', icono: 'camera_alt' },
  { nombre: 'Gasfiter', icono: 'build' },
  { nombre: 'Jardinero', icono: 'filter_vintage' },
  { nombre: 'Kinesiólogo', icono: 'queue' },
  { nombre: 'Maestro / Constructor', icono: 'business' },
  { nombre: 'Mecánico', icono: 'build' },
  { nombre: 'Nutricionista', icono: 'spa' },
  { nombre: 'Peluquera', icono: 'content_cut' },
  { nombre: 'Periodista', icono: 'edit' },
  { nombre: 'Personal Trainer', icono: 'fitness_center' },
  { nombre: 'Planners', icono: 'people' },
  { nombre: 'Productor Audiovisual', icono: 'videocam' },
  { nombre: 'Profesor Particular', icono: 'local_library' },
  { nombre: 'Psicólogo', icono: 'person_pin' },
  { nombre: 'Técnico Electrónico / Electrodomésticos', icono: 'local_shipping' },
  { nombre: 'Técnico en Computación / Informático', icono: 'laptop' },
  { nombre: 'Veterinario', icono: 'pets' },
  { nombre: 'Zapatero', icono:'airline_seat_legroom_extra' },
]


// WEBPACK FOOTER //
// ./src/app/interfaces/categorias.ts